<div class="row row-align">
  <h2>Informações do Veículo</h2>
  <app-btn-small
    class="row-align__btn"
    (click)="onClickCancelarEdicao()"
    color="primary"
    title="Cancelar edição"
    *ngIf="isShowBtnCancelarAlteracao"
  ></app-btn-small>
</div>

<app-central-loader
  text="Obtendo ficha proposta..."
  [show]="isObtendoFicha"
></app-central-loader>
<div *ngIf="!isObtendoFicha">
  <form #formVeiculoInicial="ngForm">
    <div class="row" *ngIf="!isErroFipeNaoEncontrado">
      <div class="form-group">
        <span class="icon car"></span>
        <div class="inputs">
          <label *ngIf="!fichaCadastro.hasZeroKm" for="placaVeiculo"
            >Placa do Veículo</label
          >
          <input
            *ngIf="!fichaCadastro.hasZeroKm"
            type="text"
            class="form-control"
            id="placaVeiculo"
            placeholder="BRA0S17"
            license-plate
            name="placaVeiculo"
            [(ngModel)]="fichaCadastro.placaVeiculo"
            [licensePlateCheck]="fichaCadastro.placaVeiculo"
            appShowErrorMessages
            required
          />
          <div class="row marginT10">
            <div class="col-xs-7 check-mod">
              <label for="utilizacao-agropecuaria">
                <input
                  [(ngModel)]="fichaCadastro.hasUtilizacaoAgropecuaria"
                  name="utilizacao-agropecuaria"
                  type="checkbox"
                />
                <span class="radio-label">Utilização agropecuária</span>
              </label>
            </div>

            <div class="col-xs-5 check-mod">
              <label for="veiculo-zero">
                <input
                  name="veiculo-zero"
                  [(ngModel)]="fichaCadastro.hasZeroKm"
                  type="checkbox"
                />
                <span class="radio-label">Veículo 0km</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <form #formVeiculoManual="ngForm">
    <div *ngIf="isErroFipeNaoEncontrado">
      <div class="row marginT10 veiculo-usado">
        <div class="col-xs-4 check-mod">
          <label for="veiculo-usado">
            <input
              [(ngModel)]="fichaCadastro.hasUsado"
              (change)="onChangeVeiculoZeroUsado()"
              name="veiculo-usado"
              type="checkbox"
            />
            <span class="radio-label">Veículo Usado</span>
          </label>
        </div>

        <div class="col-xs-4 check-mod">
          <label for="veiculo-zero">
            <input
              name="veiculo-zero"
              [(ngModel)]="fichaCadastro.hasZeroKm"
              type="checkbox"
              (change)="onChangeVeiculoZeroUsado()"
            />
            <span class="radio-label">Veículo 0km</span>
          </label>
        </div>

        <div *ngIf="fichaCadastro.hasZeroKm" class="col-xs-4 check-mod">
          <label for="utilizacao-agropecuaria">
            <input
              name="utilizacao-agropecuaria"
              [(ngModel)]="fichaCadastro.hasUtilizacaoAgropecuaria"
              type="checkbox"
            />
            <span class="radio-label">Utilização agropecuária</span>
          </label>
        </div>
      </div>
    </div>
  </form>

  <form #formVeiculoZero="ngForm">
    <div
      class="blue-box new-car"
      [ngClass]="{ dn: !fichaCadastro.hasZeroKm && !fichaCadastro.hasUsado }"
    >
      <div class="row">
        <div class="form-group pb0" *ngIf="isPlacaInvalida && !fichaCadastro.hasZeroKm">
          <span class="icon car"></span>
          <div class="inputs">
            <label for="user-mobile">Placa</label>
            <input
              type="text"
              readonly
              [(ngModel)]="fichaCadastro.placaVeiculo"
              class="form-control"
              name="placa-veiculo"
              license-plate
              [licensePlateCheck]="fichaCadastro.placaVeiculo"
              appShowErrorMessages
            />
          </div>
        </div>
        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="user-mobile">Categoria do Veículo</label>
            <select
              [(ngModel)]="fichaCadastro.categoriaVeiculo"
              appShowErrorMessages
              required
              [hidden]="!isLoadingTipoVeiculo"
              class="form-control"
              name="categoria-veiculo"
              (change)="onChangeTipoVeiculo($event)"
              (blur)="onBlurTipoVeiculo($event)"
            >
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let tv of listaTipoVeiculo" value="{{ tv.id }}">
                {{ tv.descricao }}
              </option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedTipoVeiculoAfterBlur">
              Categoria do Veículo é obrigatória
            </div>
            <span *ngIf="isLoadingTipoVeiculo">
              <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em>
              Carregando...</span
            >
          </div>
        </div>
        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="user-mobile">Marca do Veículo</label>
            <select
              [(ngModel)]="fichaCadastro.marcaVeiculo"
              name="marca-veiculo"
              required
              appShowErrorMessages
              [hidden]="!isLoadingMarca"
              [disabled]="!isSelectedTipoVeiculo"
              class="form-control"
              (change)="onChangeMarca($event)"
              (blur)="onBlurMarca($event)"
            >
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let ma of listaMarca" value="{{ ma.id }}">
                {{ ma.descricao }}
              </option>
            </select>
            <div
              class="text-danger"
              *ngIf="!isSelectedMarcaAfterBlur && !isLoadingMarca"
            >
              Marca do Veículo é obrigatória
            </div>
            <span *ngIf="isLoadingMarca">
              <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em>
              Carregando...</span
            >
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="user-mobile">Ano do Veículo</label>
            <select
              [(ngModel)]="fichaCadastro.anoVeiculo"
              name="ano-veiculo"
              [hidden]="!isLoadingAnoModelo"
              [disabled]="!isSelectedMarca"
              id="vehicle-model-year"
              class="form-control"
              (change)="onChangeAnoModelo($event)"
              required
              appShowErrorMessages
              (blur)="onBlurAnoModelo($event)"
            >
              <option value="" selected hidden>Selecione...</option>
              <option
                *ngFor="let am of listaAnoModelo"
                value="{{ am.anoModelo }}"
              >
                {{ am.anoModelo }}
              </option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedAnoModeloAfterBlur">
              Ano Modelo do Veículo é obrigatório
            </div>
            <span *ngIf="isLoadingAnoModelo">
              <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em>
              Carregando...</span
            >
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="user-mobile">Modelo do Veículo</label>
            <select
              [(ngModel)]="fichaCadastro.modeloVeiculo"
              name="modelo-veiculo"
              [hidden]="!isLoadingModelo"
              [disabled]="!isSelectedAnoModelo"
              id="vehicle-model"
              class="form-control"
              required
              appShowErrorMessages
              (change)="onChangeModelo($event)"
              (blur)="onBlurModelo($event)"
            >
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let mo of listaModelo" value="{{ mo.id }}">
                {{ mo.descricao }}
              </option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedModeloAfterBlur">
              Modelo do Veículo é obrigatório
            </div>
            <span *ngIf="isLoadingModelo">
              <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em>
              Carregando...</span
            >
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="user-mobile">Versão do Veículo</label>
            <select
              [(ngModel)]="fichaCadastro.versaoVeiculo"
              name="versao-veiculo"
              [disabled]="!isSelectedModelo"
              id="vehicle-version"
              class="form-control"
              required
              appShowErrorMessages
              (change)="onChangeVersao($event)"
              (blur)="onBlurVersao($event)"
            >
              <option value="" selected hidden>Selecione...</option>
              <option *ngFor="let ve of listaVersao" value="{{ ve.id }}">
                {{ ve.descricao }}
              </option>
            </select>
            <div class="text-danger" *ngIf="!isSelectedVersaoAfterBlur">
              Versão do Veículo é obrigatória
            </div>
            <span *ngIf="isLoadingVersao">
              <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em>
              Carregando...</span
            >
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
              <label for="user-mobile">Cor do Veículo</label>

              <select class="form-control" [(ngModel)]="fichaCadastro.corVeiculo" name="cor-veiculo">
                  <option value="" hidden selected>Selecione...</option>
                  <option value="AMARELA">AMARELA</option>
                  <option value="AZUL">AZUL</option>
                  <option value="BRANCA">BRANCA</option>
                  <option value="CINZA">CINZA</option>
                  <option value="DOURADA">DOURADA</option>
                  <option value="FANTASIA">FANTASIA</option>
                  <option value="GRENÁ">GRENÁ</option>
                  <option value="LARANJA">LARANJA</option>
                  <option value="MARROM">MARROM</option>
                  <option value="PRATA">PRATA</option>
                  <option value="PRETA">PRETA</option>
                  <option value="ROSA">ROSA</option>
                  <option value="ROXA">ROXA</option>
                  <option value="VERDE">VERDE</option>
                  <option value="VERMELHA">VERMELHA</option>
              </select>
          </div>
      </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="user-mobile">Tipo de Combustível</label>

            <select class="form-control" [(ngModel)]="fichaCadastro.combustivelVeiculo" name="combustivelVeiculo-veiculo">
              <option value="" hidden selected>Selecione...</option>
              <option *ngFor="let tipoCombustivel of listaTiposCombustiveis" [value]="tipoCombustivel.description">{{tipoCombustivel.description}}</option>
          </select>
          </div>
        </div>

        <div class="form-group pb0">
          <span class="icon"></span>
          <div class="inputs">
            <label for="car-value">Valor do Veículo</label>
            <div class="input-group">
              <span class="input-group-addon">R$</span>
              <input
                name="cotacao-veiculo"
                [disabled]="!isSelectedModelo"
                type="text"
                class="form-control"
                id="car-value"
                readonly
                required
                value="{{ cotacao | number: '1.2-2' }}"
              />
            </div>
            <small>Cotação FIPE</small>
            <span *ngIf="isLoadingCotacao">
              <em class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></em>
              Carregando...</span
            >
          </div>
        </div>
      </div>
    </div>
  </form>

  <form #formVeiculoUF="ngForm">
    <div class="row">
      <div class="form-group">
        <span class="icon state"></span>
        <div class="inputs">
          <label for="car-state">Estado de Licenciamento</label>
          <select
            required
            appShowErrorMessages
            requiredMessage="Selecionar UF de licenciamento é obrigatório"
            [(ngModel)]="fichaCadastro.licenciamentoUF"
            name="uf-licensing"
            class="form-control"
            id="uf-licensing"
            (change)="onChangeUfLicenciamento($event)"
          >
            <option value="" selected hidden>Selecione...</option>
            <option value="AC">AC - Acre</option>
            <option value="AL">AL - Alagoas</option>
            <option value="AP">AP - Amapá</option>
            <option value="AM">AM - Amazonas</option>
            <option value="BA">BA - Bahia</option>
            <option value="CE">CE - Ceará</option>
            <option value="DF">DF - Distrito Federal</option>
            <option value="ES">ES - Espírito Santo</option>
            <option value="GO">GO - Goiás</option>
            <option value="MA">MA - Maranhão</option>
            <option value="MT">MT - Mato Grosso</option>
            <option value="MS">MS - Mato Grosso do Sul</option>
            <option value="MG">MG - Minas Gerais</option>
            <option value="PA">PA - Pará</option>
            <option value="PB">PB - Paraíba</option>
            <option value="PR">PR - Paraná</option>
            <option value="PE">PE - Pernambuco</option>
            <option value="PI">PI - Piauí</option>
            <option value="RJ">RJ - Rio de Janeiro</option>
            <option value="RN">RN - Rio Grande do Norte</option>
            <option value="RS">RS - Rio Grande do Sul</option>
            <option value="RO">RO - Rondônia</option>
            <option value="RR">RR - Roraima</option>
            <option value="SC">SC - Santa Catarina</option>
            <option value="SP">SP - São Paulo</option>
            <option value="SE">SE - Sergipe</option>
            <option value="TO">TO - Tocantins</option>
          </select>
        </div>
      </div>
    </div>
  </form>

  <div class="row">
    <div class="marginT30 form-group tab-buttons">
      <a
        *ngIf="isShowButtonBack"
        (click)="onClickPrevious()"
        class="bt-back btn btn-border-orange pull-left"
      >
        <em class="fa fa-arrow-left mrBt"></em> Voltar</a
      >

      <a
        class="bt-go btn btn-full-orange pull-right"
        [ngClass]="{
          disabled: !isNextAvailable(
            formVeiculoInicial.valid,
            formVeiculoUF.valid,
            formVeiculoZero.valid,
            formVeiculoManual.valid
          )
        }"
        (click)="onClickNext()"
        >Continuar
        <em class="fa fa-arrow-right mlBt"></em>
      </a>
    </div>
  </div>
</div>

<app-modal-message
  #modalMessage
  [title]="'Atenção!'"
  [hideClose]="hideClose"
></app-modal-message>
